import { completionStatus } from "./completion-status";

export interface SseFrame { data: string; cursor?: number }

export const isCompletionData = (data: string): boolean => {
  if (data.trim() === "[DONE]") return true;
  try { return completionStatus(JSON.parse(data)).finished; } catch { return false; }
};

/** Preserve event names and ids; a named terminal event can have an empty data object. */
export const parseSseFrame = (block: string): SseFrame => {
  const lines = block.split(/\r\n|\r|\n/);
  let data = lines.filter(line => line.startsWith("data:")).map(line => line.slice(5).trimStart()).join("\n");
  const eventType = lines.find(line => line.startsWith("event:"))?.slice(6).trim();
  if (eventType && completionStatus({ type: eventType }).finished) {
    try {
      const payload = JSON.parse(data || "{}");
      if (payload && typeof payload === "object") data = JSON.stringify({ ...payload, type: eventType });
    } catch { /* Preserve malformed provider data for the caller to handle. */ }
  }
  const idLine = lines.find(line => line.startsWith("id:"));
  const cursor = idLine ? Number(idLine.slice(3).trim()) : undefined;
  return { data, ...(Number.isSafeInteger(cursor) && cursor! >= 0 ? { cursor } : {}) };
};

/** Some gateways omit the last SSE separator but leave the transport open. Only
 * consume a complete, explicit terminal payload early; never guess from silence. */
export const terminalSseTail = (buffer: string): SseFrame | undefined => {
  // An event header may arrive separately from its data. Wait for that payload.
  if (!/(?:^|\r|\n)data:/.test(buffer)) return undefined;
  const frame = parseSseFrame(buffer);
  return frame.data && isCompletionData(frame.data) ? frame : undefined;
};
